import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const DropdownTailwindThemes = {
  dropdown: {
    root: ({ props, state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer inline-flex relative w-full select-none outline-transparent',
        'bg-white border border-fletchers-gray-100 transition-colors duration-200 ease-in-out rounded-sm',
        'hover:border-fletchers-gray-200',
        {
          'border-fletchers-gray-200': state.overlayVisible || props.value,
          'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
          'outline-2 outline-offset-2 outline-fletchers-green-500': state.focused && !state.overlayVisible,
        },
      ),
    }),
    input: ({ props, state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer flex flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap relative',
        'bg-transparent border-0 text-fletchers-gray-200',
        'px-3 py-1.25 transition duration-200 bg-transparent rounded appearance-none font-sans text-sm',
        {
          'text-black': state.overlayVisible || props.value,
          'pr-7': props.showClear,
        },
      ),
    }),
    trigger: {
      className: classNames(
        'flex items-center justify-center shrink-0',
        'bg-transparent text-fletchers-gray-200 w-8 rounded-tr-lg rounded-br-lg',
      ),
    },
    // PrimeReact's hidden autofill `<select>` duplicates the focusable input, so it reads as a
    // second combobox — nameless, or carrying the same label twice.
    select: { 'aria-hidden': true },
    wrapper: {
      className: classNames(
        'max-h-[200px] mt-1.25 overflow-auto',
        'bg-white text-fletchers-gray-200 border-0 rounded-sm shadow-lg',
      ),
    },
    list: 'list-none',
    item: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer overflow-hidden relative whitespace-nowrap',
        'font-normal font-sans text-sm text-black',
        'm-0 px-3 py-1.5 border-0 transition-shadow duration-200 rounded-none',
        'hover:bg-fletchers-green-50 focus:outline-none',
        {
          'bg-fletchers-green-50': context.focused && !context.selected,
          'bg-fletchers-green-100 hover:bg-fletchers-green-100': context.selected,
          'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
        },
      ),
    }),
    itemgroup: {
      className: classNames('m-0 p-3 text-fletchers-gray-200 bg-white font-bold', 'cursor-auto'),
    },
    header: {
      className: classNames(
        'p-3 border-b border-gray-300 text-fletchers-gray-200 bg-gray-100 mt-0 rounded-tl-lg rounded-tr-lg',
      ),
    },
    filtercontainer: 'relative',
    filterinput: {
      className: classNames(
        'pr-7 -mr-7',
        'w-full',
        'font-sans text-sm text-fletchers-gray-200 bg-white py-3 px-3 border border-gray-300 transition duration-200 rounded-lg appearance-none',
        'hover:border-fletchers-gray-200 focus:border-fletchers-gray-200',
      ),
    },
    filtericon: '-mt-2 absolute top-1/2',
    clearicon: 'text-fletchers-gray-200 right-12 -mt-2 absolute top-1/2',
    transition: {
      enterFromClass: 'opacity-0 scale-75',
      enterActiveClass: 'transition-transform transition-opacity duration-150 ease-in',
      leaveActiveClass: 'transition-opacity duration-150 ease-linear',
      leaveToClass: 'opacity-0',
    },
  },
};
